<template>
	<div v-if="text" v-bind:style="{'min-width': textlength+'ch', 'margin': margin+'px', 'padding': '5px'}" style="word-break: keep-all;
  padding: 0px;" class="col">{{text}}</div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
  data: function () {
    return {}
  },
  mounted: function(){
    if(this.margin == undefined) this.margin=0;
  },
methods: {
  textInput: function(event){
    this.textLocal = event.target.textContent
  }
},
   props: { text: String, margin: {
      type: Number,
      default: 0
    }},
  computed: {
    textlength: function(){
      if(this.text)return this.text.length;
      else return 0;
    },
  },
  
}
</script>
<style scoped>
div {
  margin-left: auto;
  left: auto;
  right: auto;
  line-height: 2;
}
</style>